"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./sass/loadingSpinner.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingSpinner = function LoadingSpinner(_ref) {
  var color = _ref.color,
      className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(className, " loading-content")
  }, /*#__PURE__*/_react.default.createElement("svg", {
    version: "1.1",
    className: "svg-loader",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    id: "spinner",
    cx: "50",
    cy: "50",
    fill: "none",
    stroke: color,
    strokeWidth: "5",
    r: "21",
    strokeDasharray: "98.96016858807849 34.98672286269283"
  }, /*#__PURE__*/_react.default.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    repeatCount: "indefinite",
    dur: "0.819672131147541s",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1"
  }))));
};

LoadingSpinner.propTypes = {
  color: _propTypes.default.string,
  className: _propTypes.default.string
};
LoadingSpinner.defaultProps = {
  color: '#008CFF'
};
var _default = LoadingSpinner;
exports.default = _default;